class ChangeSliders {
  circles = document.querySelectorAll(".circle");
  itemContainer = document.querySelectorAll(".item-container");
  #parentElement = document.querySelector("#features");
  activeNum = 0;
  interval;

  removeActiveCircle() {
    this.circles[this.activeNum].classList.remove("active-circle");
    this.itemContainer.forEach((item) => {
      item.classList.add("d-none");
    });
  }

  addActiveCircle() {
    this.circles[this.activeNum].classList.add("active-circle");
    this.itemContainer[this.activeNum].classList.toggle("d-none");
  }

  changeActiveCircle(num) {
    // 1) remove all active circles
    this.removeActiveCircle();

    // 2) set activeNum in manuall or auto situation
    // when user click on circle
    if (num) {
      this.activeNum = num - 1;
    } else {
      // in observer situation
      this.activeNum =
        this.activeNum >= 0 && this.activeNum < this.itemContainer.length - 1
          ? ++this.activeNum
          : (this.activeNum = 0);
    }

    // 3) chose active circle with help of activNum
    this.addActiveCircle();
  }

  addHandlerManualSlider(handler) {
    window.addEventListener("click", (e) => {
      const btn = e.target.closest(".circle");
      if (!btn) return;
      const goToSlide = +btn.dataset.cirnum;
      handler(goToSlide);
    });
  }

  addHandlerAutoSlider() {
    //  guard close is for when user is not in homepage
    if (!this.#parentElement) return;

    const observer = new IntersectionObserver(
      (entries, _) => {
        const [entry] = entries;
        if (entry.isIntersecting) {
          this.interval = setInterval(this.changeActiveCircle.bind(this), 2000);
        }
        if (!entry.isIntersecting) {
          clearInterval(this.interval);
        }
      },
      {
        root: null,
        threshold: 0.5,
      }
    );
    observer.observe(this.#parentElement);
  }
}

export default new ChangeSliders();
